import api from '../services/api';
import local from '@/local/ar';
import Vue from '@/main';
import { setLookupInLocalStorage } from '@/modules/complaints/helpers/utils';
const actionNames = local.lookups;

export default {
  getComplaintStatuses(store) {
    return getData(store, 'complaintStatuses', 'getComplaintStatuses', actionNames.complaintStatuses);
  },
  getMyComplaintsRequests(_context) {
    return api.getMyComplaintsRequests();
  },
  getComplaintData(_context, socialId) {
    return api.getComplaintData(socialId);
  },
  getComplainantData(_context, socialId) {
    return api.getComplainantData(socialId);
  },
  generateMobileCode(_context, mobileNo) {
    return api.generateMobileCode(mobileNo);
  },
  getComplaintForm(_context, formId) {
    return api.getComplaintForm(formId);
  },
  updateMobileNumber(_context, mobileCode, payload) {
    return api.updateMobileNumber(mobileCode, payload);
  },
  addOrUpdateComplainantData(_context, payload) {
    return api.addOrUpdateComplainantData(payload);
  },
  getComplaintCategories(store) {
    return getData(store, 'complaintCategories', 'getComplaintCategories', actionNames.complaintCategories);
  },
  getComplaintSubCategories(_context, categoryId) {
    return api.getComplaintSubCategories(categoryId);
  },
  getExecutionCaseDetails(_context, payload) {
    return api.getExecutionCaseDetails(payload);
  },
  getICmsAllCasesDetails(_context, payload) {
    return api.getICmsAllCasesDetails(payload);
  },
  getAttachmentDetails(_context, payload) {
    return api.getAttachmentDetails(payload);
  },
  deleteComplaintRequest(_context, payload) {
    return api.deleteComplaintRequest(payload);
  },
  AddOnlineComplaintNoteRequest(_context, payload) {
    return api.AddOnlineComplaintNoteRequest(payload);
  },
  AddOnlineComplaintReopenRequest(_context, payload) {
    return api.AddOnlineComplaintReopenRequest(payload);
  },
  getOthersNoCaseDetails(_context, payload) {
    return api.getOthersNoCaseDetails(payload);
  },
  getCaseLists(_context) {
    return api.getCaseLists();
  },
  saveComplaint(_context, payload) {
    return api.saveComplaint(payload);
  },
  notifyComplainant(_context, payload) {
    return api.notifyComplainant(payload);
  },
  addBeneficiaryResponse(_context, payload) {
    return api.addBeneficiaryResponse(payload);
  },
  addBeneficiaryResponseWithAttachment(_context, payload) {
    return api.addBeneficiaryResponseWithAttachment(payload);
  },
};

const getData = ({ commit, state }, key, apiService, error, mapper = data => data) => {
  if (!state[key].length) {
    commit('update', {
      key,
      data: [],
    });
    return api[apiService]()
      .then((res) => {
        const data = mapper(res.data);
        commit('update', {
          key,
          data,
        });
        setLookupInLocalStorage(key, data);
        return data;
      })
      .catch(() => {
        Vue.toaster.error(local.errors.wentWrongWhile(error));
        return [];
      });
  } else {
    return Promise.resolve(state[key]);
  }
};

